import { atom } from "jotai";

// Switches every Power BI replacement page between live APIs and modeled fixtures.
// A fresh application session always starts with governed live data.
export const pbiMockDataEnabledAtom = atom(false);
